import React, { useState } from 'react'
import { Plus, X, Save } from 'lucide-react'
import clientesService from '../../services/clientesService'

// Cadastro rápido de fazenda do vendedor direto no passo "Vendedor" do lote.
// Grava no cadastro do cliente (fica salva pra próximos lotes) e devolve a fazenda criada.
const VAZIO = { nome: '', cidade: '', estado: '', inscricao_estadual: '', cnpj: '' }

export default function NovaFazendaInline({ organizadorId, clienteId, disabled = false, onCriada, onErro }) {
  const [aberto, setAberto] = useState(false)
  const [form, setForm] = useState(VAZIO)
  const [salvando, setSalvando] = useState(false)

  const set = (campo) => (e) => setForm(prev => ({ ...prev, [campo]: e.target.value }))

  const fechar = () => { setAberto(false); setForm(VAZIO) }

  const salvar = async () => {
    const nome = form.nome.trim()
    if (!nome) { onErro?.('Informe o nome da fazenda'); return }
    setSalvando(true)
    try {
      const payload = { nome }
      ;['cidade', 'inscricao_estadual', 'cnpj'].forEach(c => { if (form[c].trim()) payload[c] = form[c].trim() })
      if (form.estado.trim()) payload.estado = form.estado.trim().toUpperCase()
      const fazenda = await clientesService.createFazenda(organizadorId, clienteId, payload)
      onCriada?.(fazenda)
      fechar()
    } catch (err) {
      console.error('Erro ao cadastrar fazenda:', err)
      onErro?.(err?.response?.data?.detail || 'Erro ao cadastrar fazenda')
    } finally {
      setSalvando(false)
    }
  }

  if (!aberto) {
    return (
      <button
        type="button"
        onClick={() => setAberto(true)}
        disabled={disabled || !clienteId}
        className="mt-2 flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <Plus size={14} /> Cadastrar nova fazenda do vendedor
      </button>
    )
  }

  const input = 'w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm'
  return (
    <div className="mt-2 p-3 border border-blue-200 bg-blue-50 rounded-lg space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-blue-800">Nova fazenda (salva no cadastro do vendedor)</span>
        <button type="button" onClick={fechar} className="text-gray-400 hover:text-gray-600"><X size={16} /></button>
      </div>
      <input type="text" value={form.nome} onChange={set('nome')} className={input} placeholder="Nome da fazenda *" autoFocus />
      <div className="grid grid-cols-3 gap-2">
        <input type="text" value={form.cidade} onChange={set('cidade')} className={`${input} col-span-2`} placeholder="Cidade" />
        <input type="text" value={form.estado} onChange={set('estado')} className={input} placeholder="UF" maxLength={2} />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <input type="text" value={form.inscricao_estadual} onChange={set('inscricao_estadual')} className={input} placeholder="Inscrição Estadual" />
        <input type="text" value={form.cnpj} onChange={set('cnpj')} className={input} placeholder="CNPJ / CPF" />
      </div>
      <div className="flex justify-end gap-2">
        <button type="button" onClick={fechar} className="px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-lg hover:bg-gray-50">Cancelar</button>
        <button type="button" onClick={salvar} disabled={salvando} className="flex items-center gap-1 px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
          <Save size={14} /> {salvando ? 'Salvando...' : 'Salvar fazenda'}
        </button>
      </div>
    </div>
  )
}
